/**
 * Checks a successful API response payload for a Fonteva store redirect.
 *
 * When an add-to-cart style endpoint maps the requested item to the
 * Salesforce/Fonteva store, the server returns HTTP 200 with a JSON body
 * containing `fontevaStoreRedirectUrl` instead of the normal cart payload.
 * When that property is present, this helper navigates the browser to the
 * store and returns true so the caller can skip its normal success handling
 * (no cart-state update, no "Added To Cart" UI state, no error message).
 *
 * @param {object} data the parsed response payload
 * @returns {boolean} true when a redirect was triggered and normal success
 * handling should be skipped
 */
const tryFontevaStoreRedirect = (data) => {
  if (data
    && typeof data.fontevaStoreRedirectUrl === 'string'
    && data.fontevaStoreRedirectUrl.length > 0) {
    window.location.assign(data.fontevaStoreRedirectUrl);
    return true;
  }

  return false;
};

export default tryFontevaStoreRedirect;
